module.exports = __webpack_public_path__ + "img/29.8c0206c1.jpg";